import { INPUT_TYPES } from '../utils/constants.js';
export default {
    title: 'Gallery Spacing',
    description: `Set the margin between the gallery and it's container.`,
    isRelevantDescription: 'Always relevant.',
    isRelevant: () => true,
    type: INPUT_TYPES.NUMBER,
    default: 0,
};
//# sourceMappingURL=layoutParams_structure_gallerySpacing.js.map